
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, useNavigate , useLocation} from 'react-router-dom';


import ChangePassword from './ChangePassword';
import { Button, Flex, Layout ,Menu} from 'antd';

import { Header,Content,Footer } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import DistributedLead from './DistributedLead';
import QualityHold from '../quality/QualityHold';
import QualityReject from '../quality/QualityReject';
import QualityPlainSurvey from '../quality/QualityPlainSurvey';
import Quality from '../quality/Qulaity';
import QulaityLowEAC from '../quality/QulaityLowEAC';
import AlreadyRenewed from '../sales/AlreadyRenewed';
import DNC from '../sales/DNC';
import FollowUps from '../sales/FollowUps';
import NotInterested from '../sales/NotInterested';
import ReValidated from '../sales/ReValidated';
import Spoiling from '../sales/Spoiling';
import HasBroker from '../sales/HasBroker';
import Sold from '../sales/Sold';
import Voicemail from '../sales/Voicemail';
import WillRenewLater from '../sales/WillRenewLater';

import AdminSearch from './AdminSearch';
import GenerateUser from './GenerateUser';
import SurveyCallBack from '../survey/SurveyCallBack';
import PlainSurvey from '../survey/PlainSurvey';
import AdminAllLead from './AdminAllLead';
import LogOut from './LogOut';
import SurveyQuality from '../survey/SurveyQuality';
import Login from './LogINCopy';
import UserRegisteration from './UserRegisteration';
import AllLeads from '../sales/AllLeads';
import RegistrationFormSales from '../sales/RegistrationFormSales';
import RegistrationFormQuality from '../quality/RegistrationFormQuality';
import RegistrationFormAdmin from './RegistrationFormAdmin';
import QualitySearch from '../quality/QualitySearch';
import RegistrationStyling from './RegistrationStyling';
import SurveyQualityLowEAC from '../survey/SurveyQualityLowEAC';
import './design.css';
import { Image } from 'antd';
import './registration.css';
import RegistrationFormSurvey from '../survey/RegistrationFormSurvey';
import LeadSearch from '../survey/LeadSearch';
import ReValidatedRenewal from '../sales/ReValidatedRenewal';
import NewLeads from '../sales/NewLeads';
import LeadSearchAdmin from './LeadSearchAdmin';
import LeadSearchQuality from '../quality/LeadSearchQuality';
import LeadSearchSales from '../sales/LeadSearchSales';
import SurveyValidatedData from '../survey/SurveyValidatedData';
import SurveyValidatedLowEAC from '../survey/SurveyValidatedLowEAC';
import SoldRenewal from '../sales/SoldRenewal';
 



const headerStyle = {
 

  textAlign: 'center',
  color: '#fff',
  height: 100,
  paddingInline: 60,
  lineHeight: '40px',
  backgroundColor: '#024950',
  padding: '20px 0',
};
const contentStyle = {
  
  textAlign: 'center',
  minHeight: 550,
 // color: '#ffffff',
 backgroundColor: 'transparent'
  
  
};
const siderStyle = {
  textAlign: 'center',
  lineHeight: '120px',
  color: '#fff',
  backgroundColor: '#A69080',
};
const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#AC8968',
};
const layoutStyle = {
  borderRadius: 8,
  overflow: 'hidden',
  width: 1000,
  maxWidth: 1500,
};



function AppRoutes(props){
  const navigator = useNavigate();
  const location = useLocation();
  const {state={}} = location || {};
  const {token="", user={}} = state || {};
  const  isloggedIn = window.localStorage.getItem("loggedIn");
  const  loggedInUserRole = window.localStorage.getItem("userRole");

    return (
   

      <Flex gap="middle" wrap>
    

    <Layout width="100%" style={layoutStyle}>
      <Header style={headerStyle}><h1>OBSEE SOLUTIONS</h1>
    
  
      </Header>
      {/* <Header className="headerLayout">
    </Header> */}
      <Layout>
        <Sider style={siderStyle}>
        <div className="demo-logo-vertical" />
    <div>
      { 
      
      (() => {
        // if(location.pathname('/login')){
        //   <div><span>ABC</span></div>
        // }

        // else
         if(loggedInUserRole === "admin") 
          {
          return (
            <div>
           
            <Menu onClick={(item)=>{
              if((item.key === '/login') && (isloggedIn == "true")){
                window.localStorage.clear()
                navigator(item.key);
              }else{
              navigator(item.key,{state:{user:user}});
            }
            }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
            items={[
              {
                key: '/admin-all-lead',
                label: 'All Lead',
              },
              {
                key: '/admin-distribute-lead',
                label: 'Distribute Leads',
              },
              {
                key: '/admin-register-user',
                label: 'Register User',
              },
              {
                key: '/admin-change-password',
                label: 'Change Password'
              },
              {
                key: '/admin-search',
                label: 'Admin Search'
              },
              // {
              //   key: '/admin-lead-home',
              //   label: 'Admin Lead Home'
              // },
              {
                key: '/login',
                label: 'Log Out',
                //function: LogOut() 
              }
              
              
            ]}
          /></div>
          )
        } else if (loggedInUserRole === "survey") {
          return (
            <div><Menu
            onClick={(item)=>{
              if((item.key === '/login') && (isloggedIn == "true")){
                window.localStorage.clear()
                navigator(item.key);
              }else{
              navigator(item.key,{state:{user:user}});
            }
          }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
            items={[
              {
                key: '/survey-create-lead',
                label: 'Create Lead'
              },
              {
                key: '/survey-call-back',
                label: 'Call Back',
              },
              {
                key: '/survey-plain-survey',
                label: 'Plain Survey',
              },
             
              {
                key: '/survey-quality',
                label: 'Quality',
              },
              {
                key: '/survey-low-eac',
                label: 'Quality Low EAC'
              },
              {
                key: '/survey-validated',
                label: 'Validated',
              },
              {
                key: '/survey-validated-loweac',
                label: 'Validated Low EAC'
              },
              {
                key: '/quality-hold',
                label: 'Quality Hold',
              },
              {
                key: '/quality-reject',
                label: 'Quality Reject',
              },
              {
                key: '/lead-search',
                label: 'Lead Search',
              },
              {
                key: '/login',
                label: 'Log Out'
              }
            ]}
          /></div>
          )
        } 
        else if (loggedInUserRole === "quality") {
          return (
            <div><Menu
            onClick={(item)=>{
              if((item.key === '/login') && (isloggedIn == "true")){
                window.localStorage.clear()
                navigator(item.key);
              }else{
              navigator(item.key,{state:{user:user}});
            }
            }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
            
            items={[
              
              
              {
                key: '/quality-low-eac',
                label: 'Quality Low EAC'
              },
              {
                key: '/quality',
                label: 'Quality'
              },
              {
                key: '/quality-search',
                label: 'Lead Search',
              },
             {
              key: '/login',
              label: 'Log Out'
            }
            ]}
          /></div>
          )
        } 
        else if (loggedInUserRole === "sales"){
          return (
            <div> <Menu onClick={(item)=>{
              if((item.key === '/login') && (isloggedIn == "true")){
              window.localStorage.clear()
              navigator(item.key);
            }else{
            navigator(item.key,{state:{user:user}});
          }
            }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
            items={[
              {
                key: '/sales-all-leads',
               label: 'All Leads'
              },
              {
                key: '/sales/already-renewed',
                label: 'Already Renewed',
              },
              {
                key: '/sales-dnc',
                label: 'DNC',
              },
              {
                key: '/sales-followups',
                label: 'Follow Ups',
              },
              {
                key: '/sales-not-interested',
                label: 'Not Interested',
              },
              {
                key: '/sales-revalidated',
                label: 'Revalidated'
              },
              {
                key: '/sales-sold',
                label: 'Sold',
              },
              {
                key: '/sales-sold-renewal',
                label: 'Sold Renewal',
              },
              {
                key: '/sales-spoiling',
                label: 'Spoiling',
              },
              {
                key: '/sales-has-broker',
                label: 'Has Broker',
              },
              {
                key: '/sales-will-renew-later',
                label: 'Will Renew Later'
              },
              {
                key: '/sales-voicemail',
                label: 'Voicemail'
              },
              {
                key: '/sales-new-leads',
                label: 'New Leads'
             },
             {
              key: '/sales-revalidated-renewal',
              label: 'Revalidated Renewal'
           },
           {
            key: '/lead-search-sales',
            label: 'Lead Search',
          },
              {
                key: '/login',
                label: 'Log Out'
              }
             
            ]}
          /></div>
          )
        }
        else{
          return (
            <div> <Menu onClick={(item)=>{
              navigator(item.key,{state:{user:user}});
            }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
            items={[
              {
                key: '/login',
                label: 'Login',
              }
            ]}
          /></div>
          )

        }
      })()}
    </div>    
        </Sider>
        <Content width="100%"  style={contentStyle}> 
         
        <Routes>
        <Route path='/admin-all-lead' element={<AdminAllLead />} ></Route>
        <Route path='/admin-distribute-lead' element={<DistributedLead />} > </Route>
        <Route path='/admin-register-user' element={<UserRegisteration/>} > </Route>
        <Route path='/admin-change-password' element={<ChangePassword/>} > </Route>
        <Route path='/admin-search' element={<LeadSearchAdmin/>} > </Route>
        <Route path='/admin-lead-home/:id?' element={<RegistrationStyling/>} > </Route>
        <Route path='/admin-lead-style' element={<RegistrationStyling/>} > </Route>
        

        <Route path='/quality-hold' element={<QualityHold/>} > </Route>
        <Route path='/quality-reject' element={<QualityReject/>} > </Route>
        <Route path='/quality-plain-survey' element={<QualityPlainSurvey/>} ></Route> 
        <Route path='/quality' element={<Quality/>} > </Route>
        <Route path='/quality-low-eac' element={<QulaityLowEAC/>} > </Route>
        <Route path='/quality-search' element={<LeadSearchQuality/>} > </Route>

        <Route path='/survey-call-back' element={<SurveyCallBack/>} > </Route>
        <Route path='/survey-plain-survey' element={<PlainSurvey/>} ></Route> 
        <Route path='/survey-validated' element={<SurveyValidatedData/>} > </Route>
        <Route path='/survey-validated-loweac' element={<SurveyValidatedLowEAC/>} ></Route> 
        <Route path='/survey-quality' element={<SurveyQuality/>} > </Route>
        <Route path='/survey-create-lead/:id?' element={<RegistrationFormSurvey/>} > </Route> 
        {/* <Route path='/survey-create-lead' element={<RegistrationFormSurvey/>} > </Route> */}
        <Route path='/quality-lead/:id?' element={<RegistrationFormQuality/>} > </Route>
        <Route path='/lead-search' element={<LeadSearch/>} > </Route>
       
        
        
        <Route path='/survey-low-eac' element={<SurveyQualityLowEAC/>} > </Route> 

        <Route path='/sales/already-renewed' element={<AlreadyRenewed />} ></Route>
        <Route path='/sales-dnc' element={<DNC />} > </Route>
        <Route path='/sales-followups' element={<FollowUps/>} > </Route>
        <Route path='/sales-not-interested' element={<NotInterested/>} > </Route>
        <Route path='/sales-revalidated' element={<ReValidated/>} > </Route>
        <Route path='/sales-sold' element={<Sold/>} ></Route>
        <Route path='/sales-sold-renewal' element={<SoldRenewal/>} ></Route>
        <Route path='/sales-spoiling' element={<Spoiling/>}></Route>
        <Route path='/sales-has-broker' element={<HasBroker/>}></Route>
        <Route path='/sales-voicemail' element={<Voicemail />} ></Route> 
        <Route path='/sales-will-renew-later' element={<WillRenewLater />} ></Route> 
        <Route path='/sales-all-leads' element={<AllLeads />} ></Route>
        <Route path='/sales-lead/:id?' element={<RegistrationFormSales />} ></Route>
        <Route path='/sales-new-leads' element={<NewLeads />} ></Route>
        <Route path='/sales-revalidated-renewal' element={<ReValidatedRenewal />} ></Route>
        <Route path='/lead-search-sales' element={<LeadSearchSales/>} > </Route>
        
        <Route path='/login' element={<Login />} ></Route> 
        <Route path='/logout' element={<LogOut />} ></Route> 
  
      </Routes>
        </Content>
      </Layout>
      <Footer style={footerStyle}>Footer version 11</Footer>
    </Layout>

  
  </Flex>

    )
}

export default AppRoutes;